import React from 'react'

/**
 * Специальная обертка, которая в случае возникновения ошибок в дочерних компонентах
 * позволит отобразить какой-то запасной UI.
 */
export default class ErrorBoundary extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='error-boundary'>
          Упс...что-то пошло не так. Обновите страницу.
        </div>
      )
    }

    return this.props.children
  }
}
